import { AccountResponse } from '../../api/fetchDocAccounts';
import { getDoc } from '../../store/idbHandler';
import { ImageComponent, NameComponent } from './NewProfileComponents';
import ChangeDoc from '../../pages/ChangeDoc';
import { useEffect } from 'react';
import { leftArrowIcon } from './Icons';

const AccountSwitchComponent: React.FC<{
    accounts: AccountResponse['data'];
    dName: string;
    toggleShowAccount: (val: boolean) => void;
    closeDropDown?: () => void;
}> = ({ accounts, dName, toggleShowAccount, closeDropDown }) => {
    const doc = getDoc();

    if (!doc) return null;

    const accountList = accounts?.filter((acc) => acc._id !== doc._id);
    const isBusiness = accounts?.find((acc) => acc._id === doc._id)?.business?.id;

    useEffect(() => {
        return () => {
            toggleShowAccount(false);
        };
    }, []);

    return (
        <div
            className="flex max-w-360 w-360 bg-darwin-neutral_new-50 flex-col items-center gap-8 rounded-8"
            style={{
                boxShadow:
                    'rgba(0, 0, 0, 0.12) 0px 3px 6px -4px, rgba(0, 0, 0, 0.08) 0px 6px 16px 0px, rgba(0, 0, 0, 0.05) 0px 9px 28px 8px',
            }}
        >
            <div className="flex w-full pt-12 px-12">
                <span
                    className="self-start cursor-pointer"
                    onClick={() => toggleShowAccount(false)}
                >
                    {leftArrowIcon(
                        'w-14 rotate rotate-180 h-14 fill-darwin-accent-neutral_new-1000',
                    )}
                </span>
            </div>
            <div className="flex flex-col py-16 px-48 gap-8 items-center">
                <ImageComponent
                    imgUrl={doc?.profile.personal.pic || ''}
                    className="flex items-start justify-center min-w-64 min-h-64 w-64 h-64"
                />
                <NameComponent dName={dName} newDesign={true} />
                {doc.profile.professional.major_speciality?.name && (
                    <p className="text-neutral-1 text-13 text-center">
                        {doc.profile.professional.major_speciality?.name}
                    </p>
                )}
                {isBusiness ? (
                    <p className="text-neutral-1 text-13">Business Account</p>
                ) : (
                    <p className="text-neutral-1 text-13">Personal Account</p>
                )}
            </div>
            <div className="mt-auto w-full">
                {accounts && accounts.length > 1 ? (
                    <ChangeDoc
                        className="flex max-h-304 switch-profile-menu flex-col max-h-360 rounded-b-8 p-0 profile-dropdown-overlay flex flex-col p-0 profile-dropdown-overlay"
                        accountList={accountList}
                        title="Switch account"
                        closeDropDown={closeDropDown}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default AccountSwitchComponent;
